// FLAGS: identity
// Renders the step machine's current screen. Split out of LoginPage so the step order reads as a
// flat mapping rather than a five-deep nested ternary.
import GoogleSignInStep from "@src/pages/login/GoogleSignInStep";
import TotpStep from "@src/pages/login/TotpStep";
import EnrollAuthenticatorStep from "@src/pages/login/EnrollAuthenticatorStep";
import NotPermitted from "@src/pages/login/NotPermitted";
import SignUpComplete from "@src/pages/login/SignUpComplete";
import type { LoginStep } from "@src/pages/login/LoginPage";

interface LoginStepContentProps {
  step: LoginStep;
  /**
   * Authenticated but without the CustomerSuccess role. Checked ahead of `step` because it is a
   * property of the session rather than a position in the flow — a permitted-looking step must not
   * render for an account the gated endpoints will refuse.
   */
  isNotPermitted: boolean;
  onStepChange: (step: LoginStep) => void;
}

const LoginStepContent = ({
  step,
  isNotPermitted,
  onStepChange,
}: LoginStepContentProps) => {
  if (isNotPermitted) {
    return <NotPermitted onSignedOut={() => onStepChange("google")} />;
  }

  switch (step) {
    case "registered":
      return <SignUpComplete onBackToSignIn={() => onStepChange("google")} />;
    case "enroll":
      return (
        <EnrollAuthenticatorStep onEnrolled={() => onStepChange("totp")} />
      );
    case "totp":
      return <TotpStep onBack={() => onStepChange("google")} />;
    case "google":
    default:
      return (
        <GoogleSignInStep
          onTwoFactorPending={() => onStepChange("totp")}
          onEnrollRequired={() => onStepChange("enroll")}
          onRegistered={() => onStepChange("registered")}
        />
      );
  }
};

export default LoginStepContent;
